import { emailDomains } from '../constants';

export function filterEmailDomain(stringToComplete) {
  return emailDomains.filter(function (item) {
    var lastLegth = item.length < stringToComplete.length ? item.length : stringToComplete.length;
    if (item.slice(0, lastLegth) === stringToComplete) return item;
  });
}


//////////////////
// WEBPACK FOOTER
// ./src/filters/email-domains.js
// module id = ./src/filters/email-domains.js
// module chunks = 34